<template>
  <div class="flex">
    <div class="history-chat"
         :style="{height: ($route.name === 'scholarSearchHistoryGuoJiao' ||
                           $route.name === 'technicalQAHistoryGuoJiao')
                              ? `calc(100vh - 20px)`
                              : `calc(100vh - 95px)`}"
         v-loading="listDataLoading"
    >
      <div class="chat-title">
        <h3>{{ chatTitle || '新会话' }}</h3>

        <p class="technicalQA-tips flex" v-if="streamLoading && searchType === '2'">
          <span>问题回答中，请勿离开当前页面...</span>
        </p>
      </div>

      <div
        class="chat-scroll"
        ref="historyChatContainer"
        @scroll="handleScroll"
      >
        <!--  进入页面后展示列表  -->
        <div class="chat-content">
          <!--   历史问答列表   -->
          <history-chat-list-comp
            class="markdown-body"
            :chat-list-data="chatListData"
            @viewCardData="viewCardData"
          />

          <div
            v-if="!chatListData.length && !streamLoading && searchType === '2'"
          >
            <el-empty
              :description="'因您在生成中离开此页面，导致生成中断，您可以重新发起对话'"
            />
          </div>

          <!-- 专家查询推荐问题 -->
<!--          <div class="recommend-question" v-if="!streamLoading">
            &lt;!&ndash; 加载状态提示 &ndash;&gt;
            <img
              class="loading-css"
              v-if="recommendQuestionLoading"
              :src="require('@/assets/images/Loading.gif')"
              alt=""
            />
            <span
              class="item"
              v-for="(item, index) in recommendQuestionList"
              :key="index"
              @click="
                handleSendQuestion({
                  searchValue: item,
                  isInternet: isInternet,
                  searchType: '1',
                })
              "
            >
              {{ item }}
            </span>
          </div>-->

          <!--  问题正在回答中  -->
          <div
            v-if="streamLoading"
            ref="dataContainer"
            class="answering markdown-body"
          >
            <div class="question-answer">
              <div class="question-item">
                <p>{{ currentQuestion }}</p>
              </div>
              <div class="answer-item">
                <div class="avatar">
                  <img
                    :src="require('@/assets/images/common/ai-answer.png')"
                    alt=""
                  />
                </div>
                <div class="answer-con">
                  <div v-if="searchType === '1'">
                    <!-- 专家查询显示流式数据结果(回答的问题), 使用v-html渲染处理后的 Markdown -->
                    <toggle-component
                      v-if="processedThinkingHTML.length > 0"
                      :default-visible="true"
                    >
                      <div
                        class="answer-text thinking-con"
                        style="white-space: normal"
                        v-html="processedThinkingHTML"
                      ></div>
                    </toggle-component>
                    <div
                      class="answer-text"
                      style="white-space: normal"
                      v-html="processedResultHTML"
                    ></div>
                  </div>

                  <!-- 技术问答 -->
                  <div v-else-if="searchType === '2'">
                    <div v-if="streamLoading" class="flex">
                      <span>问题回答中，请勿离开当前页面...</span>
                    </div>
                    <div
                      class="answer-con"
                      style="padding: 0; white-space: pre-wrap"
                      v-html="academicQAData"
                    ></div>
                  </div>

                  <div v-else>
                    <div class="answer-text">
                      {{ normalData || '正在思考...' }}
                    </div>
                  </div>
                  <!-- 加载状态提示 -->
                  <img
                    class="loading-css"
                    v-if="streamLoading"
                    :src="require('@/assets/images/Loading.gif')"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  输入框  -->
      <div class="textarea-comp">
        <!--   回到底部按钮   -->
        <el-tooltip
          effect="dark"
          content="回到底部"
          placement="top"
          transition=""
          popper-class="hover-popper"
        >
          <div
            class="bottom-btn"
            @click="scrollToBottom"
            v-show="showScrollToBottomButton"
          >
            <i class="el-icon-arrow-down" style="color: rgb(0, 91, 172)"></i>
          </div>
        </el-tooltip>

        <!--  输入框组件  -->
        <textareaComp
          :text-area-width="`800px`"
          :rows-number="2"
          :loading="streamLoading"
          @sendQuestion="handleSendQuestion"
          @abortRequest="handleAbortRequest"
        />
      </div>
    </div>

    <div class="card-list"
         v-if="showCard"
         :style="{height: ($route.name === 'scholarSearchHistoryGuoJiao' ||
                           $route.name === 'technicalQAHistoryGuoJiao')
                              ? `calc(100vh - 20px)`
                              : `calc(100vh - 100px)`}"
         v-loading="rightCardLoading">

      <!--  检索到的文献  -->
      <paper-list-comp
        v-if="lastDataType === 2"
        :paper-list-data="paperCardData"
      />
      <!--  检索到的人才列表  -->
      <talent-list-comp
        v-else
        :talent-list-data="scholarCardData"
      />
    </div>
  </div>
</template>

<script>
import MarkdownIt from 'markdown-it';
import DOMPurify from 'dompurify'; // HTML 消毒库
import 'github-markdown-css';
import textareaComp from '@/views/scholarSearch/comps/textareaComp.vue';
import talentListComp from '@/views/scholarSearch/comps/talentListComp.vue';
import paperListComp from '@/views/scholarSearch/comps/paperListComp.vue';
import historyChatListComp from '@/views/scholarSearch/comps/historyChatListComp.vue';
import {
  getHistoryChatDetailApi,
  generateStopApi,
  scholarQueryStopApi,
  generateSurveyStopApi,
  getRecommendQuestionApi,
  scholarQueryStartApi,
} from '@/api/chat';
import { isNotEmptyObject } from '@/utils/utilsFn';
import { randomUUIDFn } from '@/utils/randomUUID';
import ToggleComponent from '@/components/ToggleComponent.vue';

export default {
  name: 'testComp',
  components: {
    ToggleComponent,
    textareaComp, // 输入框
    talentListComp, // 检索到的人才列表(右侧展示)
    paperListComp, // 检索到的论文列表(右侧展示)
    historyChatListComp, // 历史会话
  },
  props: [],
  data() {
    return {
      isNotEmptyObject, // 判断数据不是空对象方法
      listDataLoading: false, // 获取会话列表loading
      streamLoading: false, // 流式数据加载状态

      queryScholarData: '', // 专家查询数据（Markdown 格式的流数据）
      queryScholarThinking: '', // 专家查询思考过程
      academicQAData: '', // 技术问答数据
      normalData: '', // 文献调研数据
      processedThinkingHTML: '', // 使用MarkdownIt格式化后的思考过程
      processedResultHTML: '', // 使用MarkdownIt格式化后的正文

      abortController: null, // 控制中断的实例

      userId: '', // 用户id
      chatId: null, // 会话id
      sessionId: '', // 单个问答id

      chatListData: [], // 会话列表
      chatTitle: '', // 会话标题

      currentQuestion: '', // textarea输入的内容
      isInternet: false, // 是否联网
      searchType: '', // 搜索类型 '1'-专家查询；'2'-技术问答；'3'-文献调研

      // 标志位：是否需要自动滚动到最底部
      isAutoScroll: true,
      // 控制返回底部按钮的显示隐藏
      showScrollToBottomButton: false,

      showCard: false, // 右侧学者、论文卡片是否显示
      lastDataType: null, // 最后一条数据的类型
      paperCardData: {}, // 论文卡片数据
      scholarCardData: [], // 人才卡片数据

      // MarkdownIt配置
      md: new MarkdownIt({
        html: true, // 禁止原生HTML（提高安全性）
        breaks: false, // 禁止单换行转 <br>
        linkify: true, // 自动识别链接
        typographer: true, // 优化排版
      }),

      token: '',
      randomUUID: '', // UUID
      randomUUIDFn,

      rightCardLoading: false, // 右侧卡片loading(查看来源专家/查看参考文献)

      recommendQuestionList: [], // 专家查询推荐问题列表
      recommendQuestionLoading: false,
    };
  },
  created() {
    // 从localStorage中获取用户id和token
    this.userId = localStorage.getItem('at_userId') || 'test';
    this.token =
      this.$store.getters.getToken || localStorage.getItem('at_token');
    // 从params中获取会话id
    this.chatId = Number(this.$route.params.id);

    // 从params中获取输入的信息
    this.currentQuestion = this.$route.params.question || '';

    // 根据路由name 赋值searchType
    if (this.$route.name === 'scholarSearchHistory') {
      this.searchType = '1';
    }
    else if (this.$route.name === 'scholarSearchHistoryGuoJiao') {
      this.searchType = '1';
      document.title = '专家查询';
    }
    else if (this.$route.name === 'technicalQAHistory') {
      this.searchType = '2';
    }
    else if (this.$route.name === 'technicalQAHistoryGuoJiao') {
      this.searchType = '2';
      document.title = '技术问答';
    }

    // 是否联网
    this.isInternet = JSON.parse(localStorage.getItem('at_isInternet')) || false;

    // 从首页跳转至此
    if (this.currentQuestion) {
      // 处理发送问题
      this.handleSendQuestion({
        searchValue: this.currentQuestion,
        isInternet: this.isInternet,
        searchType: this.searchType,
      });
    }

    // 获取历史问答详情
    this.getHistoryChatDetail();

    // 获取sessionId
    const savedSession = sessionStorage.getItem(`session_${this.chatId}`);
    const currentQuestion = sessionStorage.getItem(
      `session_question_${this.chatId}`
    );
    if (savedSession) {
      this.currentQuestion = currentQuestion;
      this.sessionId = savedSession;
      this.streamLoading = true;

      // 赋值类型为专家查询
      this.searchType = '1';

      this.handleScholarQueryStream({
        url: `${process.env.VUE_APP_API_URL}/scholar_query/result`,
        sessionId: this.sessionId,
      });
    }
  },

  computed: {},
  methods: {
    /**
     * 处理发送问题
     * @param searchValue 搜索的内容
     * @param isInternet 是否联网
     * @param searchType 搜索类型 '1'-专家查询；'2'-技术问答
     * @returns {Promise<void>}
     */
    async handleSendQuestion({ searchValue, isInternet, searchType }) {
      try {
        this.randomUUID = this.randomUUIDFn();

        this.currentQuestion = searchValue;
        this.searchType = searchType;
        this.isInternet = isInternet;
        this.streamLoading = true;

        // 生产环境直连接口，开发环境使用代理
        const baseURL = process.env.VUE_APP_API_URL;
        // 定义请求配置文件
        const apiConfig = {
          ['2']: {
            url: `${baseURL}/generate`, // 技术问答
            params: {
              query: searchValue, // 输入
              feedback: this.isInternet, // 是否联网
            },
          },
        };

        // 滚动到最底部
        this.scrollToBottom();

        // 发起专家查询请求
        if (this.searchType === '1') {
          let params = {
            user_id: this.userId,
            question_id: this.chatId,
            prompt: searchValue, // 输入
            web_search_para: this.isInternet ? '1' : '0', // 是否联网
            user_ai_history: '', // 历史问题
          };

          // 专家查询启动生成任务获取session_id
          scholarQueryStartApi(params).then((res) => {
            if (res.success) {
              this.sessionId = res.session_id;

              // 保存 sessionId
              sessionStorage.setItem(`session_${this.chatId}`, this.sessionId);
              sessionStorage.setItem(
                `session_question_${this.chatId}`,
                this.currentQuestion
              );

              // 专家查询发起流式请求
              this.handleScholarQueryStream({
                url: `${baseURL}/scholar_query/result`,
                sessionId: this.sessionId,
              });
            }
          });
        }

        // 发送技术问答请求
        else {
          await this.handleStreamRequest({
            url: apiConfig[searchType].url,
            params: {
              user_id: this.userId,
              question_id: this.chatId,
              ...apiConfig[searchType].params,
            },
            searchType,
          });
        }
      } catch (error) {
        console.error(error);
        if (error.name !== 'AbortError') {
          this.$message.error('请求失败，请稍后重试');
        }
      } finally {
        // 数据置空
        // FIXME: this.streamLoading = false;
        this.queryScholarThinking = '';
        this.queryScholarData = '';
        this.academicQAData = '';
        this.normalData = '';
        this.recommendQuestionList = [];
      }
    },

    /**
     * 处理流式请求
     * @param url
     * @param params
     * @param searchType
     * @returns {Promise<void>}
     */
    async handleStreamRequest({ url, params, searchType }) {
      // 创建中止控制器
      this.abortController = new AbortController();

      try {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Authorization: 'Bearer ' + this.token,
          },
          body: JSON.stringify(params),
          signal: this.abortController.signal,
        });

        // 获取可读流读取器
        const reader = response.body.getReader();
        // 用于解码二进制数据
        const decoder = new TextDecoder('utf-8');
        // const decoder = new TextDecoder();
        let buffer = ''; // 数据缓冲区

        // eslint-disable-next-line no-constant-condition
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          // 解码并处理数据块
          buffer += decoder.decode(value, { stream: true });

          // 处理不同数据格式
          const processChunk = {
            // 技术问答
            ['2']: (chunk) =>
              (this.academicQAData += chunk.match(/data:\s*"(.*)"/)?.[1] || ''),
          };

          // 根据不同search调用不同方法
          processChunk[searchType](buffer);
          buffer = '';

          // 如果当前状态允许自动滚动，则调用 scrollToBottom 方法
          if (this.isAutoScroll) {
            this.scrollToBottom();
          }
        }
        this.getHistoryChatDetail();
      } finally {
        // 中止控制器置空
        this.abortController = null;
        this.streamLoading = false;
        this.currentQuestion = '';
      }
    },

    /**
     * 处理专家流式查询接口
     *  - 使用 fetch 读取后端流式数据
     *  - 按 JSON 格式解析每个数据块，从每个 JSON 中提取 content
     *  - 按 </thinking> 分割思考区与正式回答区
     *  - 防抖批量更新 Vue 响应式变量，避免频繁重绘
     */
    async handleScholarQueryStream({ url, sessionId }) {
      // 创建用于取消 Stream 请求的 AbortController
      this.abortController = new AbortController();

      // 请求地址
      const fetchUrl = url;

      // 用于暂存未完整的行数据
      let scholarBuffer = "";

      // 是否遇到 </thinking>
      let hasSplit = false;

      // 用于临时存放本次 chunk 中的 thinking/data 内容
      this.streamBuffer = { thinking: "", data: "" };

      try {
        // 发起 POST 流式请求
        const response = await fetch(fetchUrl, {
          method: "POST",
          headers: {
            Authorization: "Bearer " + this.token,
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            last_chunk_id: 0,
            session_id: sessionId
          }),
          signal: this.abortController.signal,
        });

        if (!response.body) throw new Error("ReadableStream 不存在");

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");

        // 持续读取流数据
        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          // 解码为文本
          const chunkText = decoder.decode(value, { stream: true });

          // 拼接进缓冲区
          scholarBuffer += chunkText;

          // 按换行符进行分段解析
          const lines = scholarBuffer.split("\n");

          /**
           * 最后一行可能是不完整的 JSON，不处理
           * 其余每一行都是完整的单元，逐行解析
           */
          for (let i = 0; i < lines.length - 1; i++) {
            let line = lines[i].trim();
            if (!line) continue;

            // 如果是 SSE 格式，去掉 data: 前缀
            if (line.startsWith("data:")) {
              line = line.slice(5).trim();
            }

            try {
              // 尝试解析 JSON
              const data = JSON.parse(line);
              const content = data.content || "";

              // 判断是否包含 </thinking>
              if (!hasSplit) {
                const splitIndex = content.indexOf("</thinking>");

                if (splitIndex !== -1) {
                  hasSplit = true;

                  const thinkingPart = content.slice(0, splitIndex + 11);
                  const dataPart = content.slice(splitIndex + 11);

                  if (thinkingPart) this.streamBuffer.thinking += thinkingPart;
                  if (dataPart) this.streamBuffer.data += dataPart;
                } else {
                  // 全部属于 thinking
                  this.streamBuffer.thinking += content;
                }
              } else {
                // 已进入正式回答区
                this.streamBuffer.data += content;
              }

              //  写入 Vue 响应式数据
              if (this.streamBuffer.thinking) {
                this.queryScholarThinking += this.streamBuffer.thinking;
                this.streamBuffer.thinking = "";
              }
              if (this.streamBuffer.data) {
                this.queryScholarData += this.streamBuffer.data;
                this.streamBuffer.data = "";
              }

              this.processedThinkingHTML = DOMPurify.sanitize(
                this.md.render(this.queryScholarThinking)
              );
              this.processedResultHTML = DOMPurify.sanitize(
                this.md.render(this.queryScholarData)
              );
              if (this.isAutoScroll) this.scrollToBottom();
            } catch (err) {
              // 单行解析失败，多数情况是 content 内本身带有换行、代码块等，
              // 但我们只解析整个的 JSON 行，因此不会影响下一个 chunk
              console.warn("JSON 解析失败（可能是截断）:", line);
            }
          }

          // 只保留最后未解析的一行（可能是半截 JSON）
          scholarBuffer = lines[lines.length - 1];
        }

        // 处理流结束后的残余内容
        if (this.streamBuffer.thinking || this.streamBuffer.data) {
          this.queryScholarThinking += this.streamBuffer.thinking;
          this.queryScholarData += this.streamBuffer.data;
        }

        // 状态清理
        this.streamLoading = false;
        sessionStorage.removeItem(`session_${this.chatId}`);
        sessionStorage.removeItem(`session_question_${this.chatId}`);

        this.getHistoryChatDetail();
      } catch (err) {
        console.error("流式请求出错：", err);
      } finally {
        this.streamLoading = false;
        this.currentQuestion = '';
        this.abortController = null;
      }
    },

    /**
     * 终止请求
     * @param type
     */
    handleAbortRequest(type) {
      if (this.abortController) {
        this.abortController.abort(); // 中止当前控制器关联的请求
        this.abortController = null; // 释放引用
      }

      // 终止接口公共参数
      let commonParams = {
        user_id: this.userId,
        question_id: this.chatId,
      };
      const currentQuestion = this.currentQuestion;

      // 终止专家查询
      if (type === '1') {
        let params = {
          ...commonParams,
          prompt: this.currentQuestion, // 输入
          web_search_para: this.isInternet ? '1' : '0', // 是否联网
          user_ai_history: '', // 历史问题
        };
        scholarQueryStopApi(params).then((res) => {
          if (res.success) {
            this.chatListData.push({
              question: currentQuestion,
              answer: '本次回答已被终止',
            });

            this.scrollToBottom();
          }
        });
      }
      // 终止技术问答
      else if (type === '2') {
        let params = {
          ...commonParams,
          query: this.currentQuestion, // 输入
          feedback: this.isInternet, // 是否联网
        };
        generateStopApi(params).then((res) => {
          if (res.status === 'success') {
            this.chatListData.push({
              question: currentQuestion,
              answer: '本次回答已被终止',
            });

            this.scrollToBottom();
          }
        });
      }
      // 终止文献调研
      else if (type === '3') {
        let params = {
          ...commonParams,
          topic: this.currentQuestion, // 输入
          task_id: this.randomUUID,
        };
        generateSurveyStopApi(params).then((res) => {
          if (res.status === 'success') {
            this.chatListData.push({
              question: currentQuestion,
              answer: '本次回答已被终止',
            });

            this.scrollToBottom();
          }
        });
      }
    },

    // 获取历史会话记录
    getHistoryChatDetail() {
      getHistoryChatDetailApi({ user: this.userId, id: this.chatId })
        .then((res) => {
          if (res === '没有对应id') {
            this.$router.push({ name: 'newChat' });
            return;
          }
          // 遍历返回的数据，对数据进行操作
          res.content?.map((item) => {
            // 添加是否翻译字段
            item.isTranslated = false;
            item.isTranslating = false;
            // 添加翻译后的字段
            item.translatedValue = '';

            if (!item.answer) return false;
            if (item.type === 1) {
              // 使用MarkdownIt格式化markdown数据
              item.answer = this.markdownItFn(item.answer || '');
              item.thinking = this.markdownItFn(item.thinking || '');
            }
          });

          // 数据赋值
          this.chatListData = res.content;
          this.chatTitle = res.title;
          // 如果最后一项是专家查询或者技术问答时，显示右侧卡片
          if (!this.chatListData.length) return false;
          this.lastDataType =
            this.chatListData[this.chatListData.length - 1].type;
          const isScholar = this.lastDataType === 1;
          const isQA = this.lastDataType === 2;

          // 专家查询
          if (isScholar && this.chatListData[this.chatListData?.length - 1]?.scholar_card.length) {
            this.scholarCardData =
              this.chatListData[this.chatListData.length - 1].scholar_card;

            // 获取专家查询推荐问题列表
            // this.getRecommendQuestion(
            //   this.chatListData[this.chatListData.length - 1].question,
            //   this.chatListData[this.chatListData.length - 1].answer,
            // );
          }

          // 技术问答
          if (isQA) {
            this.paperCardData =
              this.chatListData[this.chatListData.length - 1].refs;
          }

          // 是否显示右侧卡片
          this.showCard =
            (this.scholarCardData &&
              this.scholarCardData.length) ||
            (isQA && this.isNotEmptyObject(this.paperCardData));

          // 获取成功数据后展示数据的最底部
          setTimeout(() => {
            this.scrollToBottom();
          }, 0);
        })
        .finally(() => {
          this.listDataLoading = false;
        });
    },

    // 滚动到最底部的方法
    scrollToBottom() {
      // 确保 DOM 已更新后再执行滚动操作
      this.$nextTick(() => {
        // 获取滚动容器的 DOM 元素
        const container = this.$refs.historyChatContainer;

        if (container) {
          // 设置 scrollTop 属性为 scrollHeight，即将滚动条滚动到最底部
          container.scrollTop = container.scrollHeight;
        }
      });
    },

    // 滚动事件处理函数
    handleScroll() {
      // 获取滚动容器的 DOM 元素
      const scrollBox = this.$refs.historyChatContainer;

      // 如果元素存在, 判断是否滚动到了最底部
      if (scrollBox) {
        // scrollHeight 滚动容器的总高度，
        // clientHeight 滚动容器的可视高度，
        // scrollTop 滚动条距离顶部的距离
        const { scrollTop, clientHeight, scrollHeight } = scrollBox;

        // 更新标志位，决定是否需要自动滚动。容差值10px避免浏览器渲染差异
        this.isAutoScroll = scrollTop + clientHeight >= scrollHeight - 10;

        // 显示回到底部按钮
        this.showScrollToBottomButton =
          scrollTop + clientHeight + 50 < scrollHeight;
      }
    },

    // 使用MarkdownIt格式化markdown数据
    markdownItFn(val) {
      return DOMPurify.sanitize(this.md.render(val));
    },

    /**
     * 查看历史回答卡片列表
     * @param type 查看的类型
     * @param index 下标
     */
    viewCardData({ type, index }) {
      this.rightCardLoading = true;

      if (type === 'scholar') {
        this.scholarCardData = [];
        this.showCard = true;
        this.lastDataType = 1;
        setTimeout(() => {
          this.rightCardLoading = false;
          this.scholarCardData = this.chatListData[index].scholar_card;
        }, 500);
      } else if (type === 'paper') {
        this.showCard = true;
        this.lastDataType = 2;
        setTimeout(() => {
          this.paperCardData = this.chatListData[index].refs;
          this.rightCardLoading = false;
        }, 500);
      }
    },

    // 获取专家查询-推问题题列表
    getRecommendQuestion(question, answer = '') {
      this.recommendQuestionLoading = true;
      getRecommendQuestionApi({
        question,
        answer,
      })
        .then((res) => {
          this.recommendQuestionList = res.data;
          this.scrollToBottom();
        })
        .finally(() => {
          this.recommendQuestionLoading = false;
        });
    },

    // 简单哈希函数（替代方案：使用 crypto-js 的 MD5）
    _generateHash(str) {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }
      return hash;
    },
  },

  mounted() {
    // 初始化时确保滚动条在最底部
    setTimeout(() => {
      this.scrollToBottom();
    }, 500);
    window.addEventListener('beforeunload', this.handleAbortRequest);
  },

  // 销毁组件钩子
  beforeDestroy() {
    this.handleAbortRequest(); // 销毁前中止所有请求

    window.removeEventListener('beforeunload', this.handleAbortRequest);
  },

  watch: {
    // // 监听问题是否回答完毕
    streamLoading: {
      handler(nv) {
        // console.log(nv);
        // 如果正在回答中，隐藏右侧卡片
        if (nv) {
          this.showCard = false; // 隐藏右侧卡片
        }
      },
    },

    // 监听路由id，发生改变后调接口
    ['$route.params.id']: {
      handler(newId) {
        // console.log('路由id发生改变', newId);
        this.showCard = false; // 隐藏右侧卡片
        this.chatListData = []; // 数据置空
        this.chatTitle = ''; // 标题置空

        this.chatId = Number(newId);
        this.listDataLoading = true;
        // 获取历史数据
        this.getHistoryChatDetail();

        // 终止请求
        this.streamLoading = false;
        this.handleAbortRequest();

        // 清空专家查询推荐问题
        this.recommendQuestionList = [];

        if (this.$route.name === 'technicalQAHistory') {
          this.searchType = '2';
        } else if (this.$route.name === 'scholarSearchHistory') {
          this.searchType = '1';
        }
      },
      immediate: false,
    },
  },
};
</script>

<style scoped lang="less">
.history-chat {
  position: relative;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex: 1;

  .chat-title {
    //width: 100%;
    margin: 0 auto 10px;
    text-align: center;
    height: 45px;
    line-height: 45px;
    width: 800px;
    position: relative;
    //box-shadow: 0 0 5px 0 #dbeafedd;

    > h3 {
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 800px;
      margin: 0 auto;
    }
    > div {
      height: 10px;
      background: linear-gradient(
        rgba(255, 255, 255, 0.8) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  .chat-scroll {
    overflow-y: auto;
    flex: 1;
    /* 隐藏IE/Edge的滚动条 */
    -ms-overflow-style: none;
    /* 隐藏Firefox的滚动条 */
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .chat-content {
    flex: 1;
    overflow-y: auto;
    width: 80%;
    max-width: 900px;
    min-width: 580px;
    margin: 0 auto;
    padding-bottom: 5px;
    //background-color: #F6F8FD;

    .question-answer {
      //width: 800px;
      margin: 0 auto 10px;
      padding-right: 40px;
      position: relative;
    }
    .question-item {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 10px;
      margin-right: -20px;
      > p {
        max-width: 500px;
        padding: 12px 15px;
        background: #eff6ff;
        border-radius: 8px;
        line-height: 1.5;
        margin-right: 10px;
      }
    }
    .answer-item {
      display: flex;
      white-space: pre-wrap;

      .avatar {
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        flex-shrink: 0;

        img {
          height: 22px;
        }
      }

      .answer-con {
        flex: 1;
        text-align: left;
        padding: 5px 20px 20px;

        .answer-text {
          //display: flex;
          flex-wrap: wrap;
          width: 100%;
          text-align: justify;
          //margin-bottom: 10px;
        }
        .deep-thinking-tips {
          height: 40px;
          line-height: 40px;
          font-size: 15px;
          color: #999;
        }
        .thinking-con {
          background-color: rgba(243, 244, 246, 0.8);
          padding: 15px;
          border-radius: 8px;
          width: 95.5%;
          //opacity: 0.7;
          font-size: 14px;
          color: #888;
          margin-bottom: 10px;
          line-height: 1.8;
        }

        .download-literature {
          span {
            cursor: pointer;
            color: rgb(0, 91, 172);

            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
    .answering {
      padding-top: 15px;
      border-top: 1px dashed rgba(0, 0, 0, 0.1);
      position: relative;
      //background-color: #F6F8FD;
    }
  }

  .textarea-comp {
    justify-content: center;
    align-items: center;
    //margin: 0 auto 30px;
    position: relative;
    //border-top: 10px solid #ffffff;
    //box-shadow: 0 0 10px 0 #dbeafedd;

    width: 80%;
    min-width: 580px;
    margin: 20px auto 22px;
    max-width: 800px;

    .bottom-btn {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: -60px;
      right: 0;
      left: 0;
      margin: auto;
      color: #8b8b8b;
      cursor: pointer;
      background-color: #ffffff;
      z-index: 999;
      box-shadow:
        0 0 4px 0 rgba(0, 0, 0, 0.02),
        0 6px 10px 0 rgba(47, 53, 64, 0.1);

      &:hover {
        background-color: #f5f5f5;
      }

      i {
        font-size: 22px;
        font-weight: bold;
      }
    }
  }
}

.card-list {
  min-width: 350px;
  max-width: 500px;
  width: 33%;
  height: calc(100vh - 100px);
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  overflow-y: auto;
  //border-bottom: 30px solid #F6F8FD;
  //border-bottom: 30px solid #fff;
  box-sizing: border-box;
}

.loading-css {
  width: 30px;
}

.recommend-question {
  padding-left: 55px;
  display: flex;
  flex-direction: column;
  grid-gap: 10px;
  gap: 10px;
  align-items: flex-start;
  align-self: stretch;
  justify-content: center;
  margin-top: 14px;

  .item {
    display: inline-block;
    width: auto;
    cursor: pointer;
    font-size: 14px;
    color: #999999;
    border-radius: 6px;
    padding: 5px 10px;
    border: 1px solid #999;

    &:hover {
      color: #333;
      border-color: #333333;
    }
  }
}

.markdown-body /deep/ .thinking-con p {
  margin: 0 !important;
}
.markdown-body /deep/ table {
  max-width: 790px!important;
}

.markdown-body table {
  background-color: #ffffff !important;
  color: #333333 !important;
  border-collapse: collapse;
}

.markdown-body /deep/ tr {
  background-color: #ffffff;
  color: #333333 !important;

  &:nth-child(2n) {
    background-color: #f6f8fa!important;
  }
}

.markdown-body /deep/ hr {
  background-color: #d1d9e0!important;
}

.markdown-body /deep/ th,
.markdown-body /deep/ td {
  color: #000000 !important;
  border: 1px solid #ddd!important;
}


.technicalQA-tips {
  position: absolute;
  top: 45px;
  left: 260px;
  z-index: 99999;
  padding: 10px 30px;
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  background-color: #ffffff;
  box-shadow: 0 2px 8px #6874ad40;
  display: flex;
  justify-content: center;

  span {
    height: 24px;
    line-height: 24px;
    font-weight: normal;
    color: #666666;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans',
    Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji';
  }
}

</style>
